import { render, staticRenderFns } from "./productCounterTitle.vue?vue&type=template&id=681f2768&scoped=true&"
import script from "./productCounterTitle.vue?vue&type=script&lang=js&"
export * from "./productCounterTitle.vue?vue&type=script&lang=js&"
import style0 from "./productCounterTitle.vue?vue&type=style&index=0&id=681f2768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f2768",
  null
  
)

export default component.exports